import DOMPurify from 'dompurify'
import linkifyHtml from 'linkify-html'
import { ref, watch } from 'vue'
import { User, UserLite } from '../../../libs/models'
import { useRouter } from 'vue-router'
export const toHtmlMessage = (message: string) => {
  const clean = DOMPurify.sanitize(message, { ALLOWED_TAGS: [] })
  const linkedText = linkifyHtml(clean, {
    defaultProtocol: 'https',
    attributes: (href, type) => {
      if (type !== 'url') return {}
      return href.startsWith(location.origin)
        ? {}
        : { target: '_blank', rel: 'noopener noreferrer' }
    }
  })
  // Convert hashtags to links, but avoid matching hashtags inside URLs
  // Split by <a> tags to process only text outside of links
  const parts = linkedText.split(/(<a[^>]*>.*?<\/a>)/g)
  return parts.map(part => {
    // If this part is an anchor tag, return it unchanged
    if (part.startsWith('<a') && part.endsWith('</a>')) {
      return part
    }
    // Otherwise, process hashtags in this text segment
    const hashtagRegex = /(#[^\s]+)/g
    return part.replace(hashtagRegex, (_match, hashtag) => {
      // Escape attribute delimiters while preserving existing HTML entities.
      const tag = hashtag.substring(1).replace(/"/g, '&quot;')
      return `<a href="#" data-hashtag="${tag}">${hashtag}</a>`
    })
  }).join('')
}
export const tagWord = ref('')
export const useTagModal = () => {
  const router = useRouter()
  const open = (word: string) => {
    tagWord.value = word
    profileModalUser.value = undefined
    if (router.currentRoute.value.name === 'User') {
      router.replace({ name: 'Top' })
    }
  }
  return {
    open
  }
}
export const profileModalUser = ref<User | number>()
export const useProfileModal = () => {
  const router = useRouter()
  const toUserOrId = (user: User | UserLite | number) => {
    if (typeof user === 'number') {
      return user
    } else if ('desc' in user) {
      return user
    } else {
      return user.id
    }
  }
  const toUserId = (user: User | UserLite | number) => {
    if (typeof user === 'number') {
      return user
    } else {
      return user.id
    }
  }
  const open = (user: User | UserLite | number) => {
    if (router.currentRoute.value.name === 'User') {
      router.replace({ name: 'User', params: { userId: toUserId(user) } })
      profileModalUser.value = undefined
    } else {
      profileModalUser.value = toUserOrId(user)
    }
    tagWord.value = ''
  }
  return {
    open
  }
}
